export const normalizeMinimumLeadTimeMinutes = (value) =>
  Math.max(0, Math.floor(Number(value) || 0));

export const formatLeadTimeLabel = (value) => {
  const minutes = normalizeMinimumLeadTimeMinutes(value);

  if (minutes <= 0) {
    return '';
  }

  if (minutes % 1440 === 0 && minutes >= 2880) {
    return `${minutes / 1440} dias`;
  }

  const hours = minutes / 60;
  const formattedHours = Number.isInteger(hours)
    ? String(hours)
    : hours.toFixed(1).replace('.', ',');
  return `${formattedHours} ${hours === 1 ? 'hora' : 'horas'}`;
};

export const formatLeadTimeNotice = (value) => {
  const label = formatLeadTimeLabel(value);
  return label ? `Encomenda com antecedência mínima de ${label}` : '';
};

export const formatDateTimeLocal = (value) => {
  const date = value instanceof Date ? new Date(value.getTime()) : new Date(value);

  if (Number.isNaN(date.getTime())) {
    return '';
  }

  date.setMinutes(date.getMinutes() - date.getTimezoneOffset());
  return date.toISOString().slice(0, 16);
};

export const buildMinimumAllowedDeliveryDate = (leadTimeMinutes) => {
  const date = new Date();
  date.setSeconds(0, 0);
  date.setMinutes(date.getMinutes() + normalizeMinimumLeadTimeMinutes(leadTimeMinutes));
  return date;
};

export const getRequiredLeadTimeMinutes = (items) =>
  (Array.isArray(items) ? items : []).reduce(
    (highestLeadTime, item) =>
      Math.max(highestLeadTime, normalizeMinimumLeadTimeMinutes(item?.minimumLeadTimeMinutes)),
    0,
  );

export const getLeadTimeDrivers = (items) => {
  const requiredMinutes = getRequiredLeadTimeMinutes(items);

  if (requiredMinutes <= 0) {
    return [];
  }

  return [...new Set(
    (Array.isArray(items) ? items : [])
      .filter(
        (item) => normalizeMinimumLeadTimeMinutes(item?.minimumLeadTimeMinutes) === requiredMinutes,
      )
      .map((item) => String(item?.nome || item?.name || '').trim())
      .filter(Boolean),
  )];
};

export const getLeadTimeRequirement = (items) => {
  const requiredMinutes = getRequiredLeadTimeMinutes(items);
  const drivers = getLeadTimeDrivers(items);

  return {
    requiredMinutes,
    requiredLabel: formatLeadTimeLabel(requiredMinutes),
    drivers,
  };
};
